module.exports = __webpack_public_path__ + "img/SPRINT_GAMING_PNG-.56ba3e74.png";